<template>
  <div class="h-screen">
    <slot />
  </div>
</template>
